module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (253).7fa30dce.jpg";